module.exports = {"url":{"hash":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/syncHash.json","sync":"https://s3-eu-west-1.amazonaws.com/launcher.eveonline.com/resources/sync.json"}}


//////////////////
// WEBPACK FOOTER
// ./src/settings/sync.dev.json
// module id = 978
// module chunks = 0